module.exports = __webpack_public_path__ + "img/bg.0d44944.jpg";